import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';
import { CancelToken,AxiosRequestConfig} from 'axios';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, TagProps } from './models'



export const setDeviceAsset = (id:string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.post(`${API_URL}/devices/${id}/assets`, params);
};
export const addAsset = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/assets`, params);
};

export const getAssetList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/assets`, { params });
}

export const getAssetAll = (): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/assets/list`);
}

export const getAssetById = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/assets/${id}`);
}
export const deleteAsset = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/assets/${id}`);
}

export const getAssetsStatistic = (params:any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/assets/statistic`, { params });
}
export const getStatisticExcel = (params:any): Promise<any> => {
  var requestConfig:AxiosRequestConfig={
    responseType:"blob",
    params:params
  }
  return AxiosInstance.get(`${API_URL}/assets/export`, requestConfig);
}